import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  PasswordInputsInterface,
  schema as schemaYup,
} from '@/pages/signUp/signUpPassword/yupPasswordFields';
import React, { ReactElement } from 'react';
import {
  SignUpControllerInterface,
  UserSignPasswordInterface,
} from '../SignUpInterface';

export const SignUpPasswordController = ({
  hasLetter,
  hasNumber,
  user,
  setUser,
}: PasswordInputsInterface & SignUpControllerInterface) => {
  const schema = schemaYup({ hasLetter, hasNumber });
  const {
    control,
    watch,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<UserSignPasswordInterface>({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const controlledTextView = (
    children: ReactElement,
    fieldName: 'password' | 'confirmPassword',
    setConfirmPassword?: (value: string) => void
  ) => {
    return (
      <Controller
        name={fieldName}
        control={control}
        defaultValue={user['password']}
        render={({ field }) =>
          React.cloneElement(children, {
            onValueChange: (value: string) => {
              if (setConfirmPassword) {
                setConfirmPassword(value);
              } else {
                setUser({
                  ...user,
                  [fieldName]: value,
                });
              }
              field.onChange(value);
            },
            error: !!errors[fieldName],
            helperText: errors[fieldName]?.message,
          })
        }
      />
    );
  };

  return { watch, isValid, controlledTextView, handleSubmit };
};
